/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-05-09
 * @brief EHP Header 컴포넌트
 *
 ********************************************************************/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useRef } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
//import "/static/css/style.css"
import $ from "jquery";
//recoil
import { useRecoilValue, useRecoilState, useSetRecoilState, useResetRecoilState } from "recoil";
import { langState } from '../../recoil/langState';
import { urlState, menuState, headerSettingState, headerAlarmState, headerUserInfoState, treeMenuState, loadingBoxState } from '../../recoil/menuState';
//
import { userInfoLoginState, userInfoState } from "../../recoil/userState";
//utils
import * as i18n from '../../utils/langs/i18nUtils';
import { useTrans } from '../../utils/langs/useTrans';
import clog from "../../utils/logUtils";
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
import * as HTTPUTIL from "../../utils/api/HttpUtil";
import * as USERUTIL from "../../utils/user/userUtils";
import AlarmCount from "./AlarmCount";
import Nav from "../leftnav/Nav";
/**
 * @brief EHP 헤더 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function Header(props) {
    //trans, navgate, ref
    const navigate = useNavigate();
    const mobileRef = useRef(null); // Mobile Check용
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilUrl = useSetRecoilState(urlState);
    const [hbMenuToggle, setRecoilHbMenuToggle] = useRecoilState(menuState);
    const [settingPopup, setRecoilSettingPopup] = useRecoilState(headerSettingState);
    const [alarmPopup, setRecoilAlarmPopup] = useRecoilState(headerAlarmState);
    const [userInfoPopup, setRecoilUserInfoPopup] = useRecoilState(headerUserInfoState);
    const [treeOpen, setRecoilTreeOpen] = useRecoilState(treeMenuState);
    const [alarmCount, setAlarmCount] = useState(0); // 읽지 않은 alarm
    const [alarmCountReload, setAlarmCountReload] = useState(false);
    const [isWindow, setIsWindow] = useState(true);
    const [isPFMobile, setIsPFMobile] = useState(false);
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if (!CUTIL.isnull(mobileTag)) {
                //clog("WIDTH : " + mobileTag.clientWidth);
                if (mobileTag.clientWidth <= 1500) {
                    setIsWindow(false);
                }
                else {
                    setIsWindow(true);
                }
                if (mobileTag.clientWidth <= 758) {
                    setIsPFMobile(true);
                }
                else {
                    setIsPFMobile(false);
                    setRecoilTreeOpen(true);
                }
            }
        }
        handleResize(); // init ismobile check
        window.addEventListener("resize", handleResize); // resize ismobile check
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    function showRightSideBar() {
        $(".navbar__menu li.active").removeClass("active");
        $(".navbar").addClass("active");
    }
    function hideRightSideBar() {
        $(".navbar").removeClass("active");
    }
    function handleHamBtnClick(e) {
        clog("토글 사이드바 버튼클릭");
        //      if (active) {
        if (hbMenuToggle) {
            clog("토글 사이드바 버튼클릭 - active");
            hideRightSideBar();
        }
        else {
            clog("토글 사이드바 버튼클릭 - not active");
            showRightSideBar();
        }
        //setActive(active?false:true);
        setRecoilHbMenuToggle(hbMenuToggle ? false : true);
        //
        setRecoilSettingPopup(false);
        setRecoilUserInfoPopup(false);
        setRecoilAlarmPopup(false);
    }
    function onClickFuncBtn(e, type) {
        setRecoilHbMenuToggle(false);
        if (isPFMobile) {
            setRecoilTreeOpen(false);
        }
        if (type === "SETTING") {
            setRecoilSettingPopup(!settingPopup); // toggle
            setRecoilUserInfoPopup(false);
            setRecoilAlarmPopup(false);
        }
        else if (type === "USER") {
            setRecoilSettingPopup(false);
            setRecoilUserInfoPopup(!userInfoPopup); // toggle
            setRecoilAlarmPopup(false);
        }
        else if (type === "ALARM") {
            setRecoilSettingPopup(false);
            setRecoilUserInfoPopup(false);
            setRecoilAlarmPopup(!alarmPopup); // toggle
        }
    }
    function onClickGoPage(url) {
        // 페이지 이동
        //setRecoilUrl(url);
        //navigate(CONST.URL_EHP);
        navigate(url);
        setRecoilHbMenuToggle(false);
    }
    //clog("PERFECT MOBILE : " + isPFMobile);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { ref: mobileRef },
            React.createElement("div", { className: "header__left" },
                React.createElement("a", { href: "#", className: !hbMenuToggle ? "navbar__toggleBtn" : "navbar__toggleBtn active", onClick: (e) => { handleHamBtnClick(e); } },
                    React.createElement("span", { className: "hide" }, "\uC804\uCCB4\uBA54\uB274")),
                React.createElement("h1", { style: { "cursor": "pointer" }, className: "header__title" },
                    React.createElement("a", { onClick: (e) => (userInfo.loginInfo.role !== CONST.USERROLE_NONE) && onClickGoPage(CONST.URL_DASHBOARD) },
                        React.createElement("h1", { className: "header__title" },
                            React.createElement("img", { src: require("/static/img/logo_login_title.png"), alt: "e-Health Portal" }))))),
            React.createElement("div", { className: "header__right" },
                React.createElement("ul", { className: "header__etc", style: { "cursor": "default" } },
                    React.createElement("li", { className: (settingPopup) ? "active" : "" },
                        React.createElement("a", { className: "btn btn-set", onClick: (e) => { onClickFuncBtn(e, "SETTING"); } },
                            React.createElement("span", { className: "hide" }, "\uD658\uACBD\uC124\uC815"))),
                    React.createElement("li", { className: (alarmPopup) ? "active" : "" },
                        React.createElement("a", { className: "btn btn-alarm", onClick: (e) => { onClickFuncBtn(e, "ALARM"); } },
                            React.createElement("span", { className: "hide" }, "\uC0C8\uC54C\uB9BC"),
                            React.createElement(AlarmCount, { alarmCountReload: alarmCountReload, setAlarmCountReload: setAlarmCountReload, setAlarmCount: setAlarmCount }))),
                    React.createElement("li", { className: (userInfoPopup) ? "active" : "" },
                        React.createElement("a", { className: "btn btn-admin", onClick: (e) => { onClickFuncBtn(e, "USER"); } },
                            React.createElement("span", null, userInfo.userName)))),
                React.createElement("div", { className: "header__logo" },
                    React.createElement("span", { className: "hide" }, "LS"))),
            React.createElement(Setting, { settingPopup: settingPopup }),
            React.createElement(UserInfo, { userInfoPopup: userInfoPopup }),
            React.createElement(Alarm, { alarmPopup: alarmPopup, alarmCount: alarmCount, setAlarmCountReload: setAlarmCountReload })),
        React.createElement(Nav, { handleClick: handleHamBtnClick, isWindow: isWindow })));
}
export default Header;
function Setting(props) {
    // use recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //
    const isOpen = props.settingPopup;
    // 다국어 설정 변경 및 recoil 상태 변경
    function exchgLanguage(e, selLang) {
        return __awaiter(this, void 0, void 0, function* () {
            /*var curTag = (e.target.tagName == "SAPN")?e.currentTarget:e.target; // button
            var sttBtnDiv = curTag.closest(".setting__btn");
        
            for ( var i = 0; i < sttBtnDiv.children.length; i ++) {
              var childBtn = sttBtnDiv.children[i];
              childBtn.classList.remove("on");
            }
        
            curTag.classList.add("on");
            */
            saveUserLangs(selLang);
        });
    }
    function saveUserLangs(frontLang) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiLang = CUTIL.apiLangSet(frontLang);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": "/api/v2/user/setting/language",
                appQuery: {
                    "language": apiLang,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    const nUserInfo = USERUTIL.getDetailUserInfoR(userInfo.loginInfo);
                    clog("IN HEADER : CHANGELANGS : " + JSON.stringify(nUserInfo));
                    yield i18n.changeLang(frontLang);
                    setRecoilLangs(frontLang);
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: "header__setting", style: { display: (isOpen) ? "" : "none", "cursor": "default" } },
            React.createElement("li", null,
                React.createElement("p", null, "\uC5B8\uC5B4"),
                React.createElement("div", { className: "setting__btn" },
                    React.createElement("button", { type: "button", className: (langs == CONST.STR_LANG_KOR) ? "on" : "", onClick: (e) => (langs !== CONST.STR_LANG_KOR) && exchgLanguage(e, CONST.STR_LANG_KOR) },
                        React.createElement("span", null, "\uD55C\uAD6D\uC5B4")),
                    React.createElement("button", { type: "button", className: (langs == CONST.STR_LANG_ENG) ? "on" : "", onClick: (e) => (langs !== CONST.STR_LANG_ENG) && exchgLanguage(e, CONST.STR_LANG_ENG) },
                        React.createElement("span", null, "English")),
                    React.createElement("button", { type: "button", className: (langs == CONST.STR_LANG_CHA) ? "on" : "", onClick: (e) => (langs !== CONST.STR_LANG_CHA) && exchgLanguage(e, CONST.STR_LANG_CHA) },
                        React.createElement("span", null, "\u4E2D\u6587")))))));
}
function UserInfo(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoState);
    const resetRecoilUserInfo = useResetRecoilState(userInfoState);
    const setRecoilUrl = useSetRecoilState(urlState);
    const isOpen = props.userInfoPopup;
    //
    const navigate = useNavigate();
    //
    function onClickLogout(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/api/v2/auth/logout?userId=${userInfo.userId}`,
                appQuery: {
                    userId: userInfo.userId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    // Y/N 체크 필요?
                    sessionStorage.removeItem(CONST.STR_TOKEN);
                    sessionStorage.removeItem(CONST.STR_TOKEN_EXPIRETIME);
                    localStorage.removeItem(CONST.STR_USERID);
                    localStorage.removeItem(CONST.STR_USERROLE);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN_EXPIRETIME);
                    //
                    resetRecoilUserInfo();
                    //
                    setRecoilUrl(CONST.URL_LOGIN);
                    navigate(CONST.URL_EHP);
                }
                else {
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: "header__userinfo", style: { display: (isOpen) ? "" : "none", "cursor": "default" } },
            React.createElement("li", null,
                React.createElement("a", { style: { "cursor": "pointer" }, className: "js-open", "data-pop": "pop-myaccount", onClick: (e) => CUTIL.jsopen_Popup(e) }, "My Account")),
            React.createElement("li", null,
                React.createElement("a", { style: { "cursor": "pointer" }, className: "js-open", "data-pop": "pop-logout", onClick: (e) => CUTIL.jsopen_Popup(e) }, "Logout")))));
}
function Alarm(props) {
    //trans, navigate
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    //props
    const isOpen = props.alarmPopup;
    const alarmCount = props.alarmCount;
    const setParentAlarmCountReload = props.setAlarmCountReload;
    const [onlyUnread, setOnlyUnread] = useState(false);
    let appPath = "";
    if (onlyUnread) {
        appPath = "?status=unread";
    }
    const [alarmList, setAlarmList] = useState([]);
    const [listReload, setListReload] = useState(false);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/notice/messages${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: isOpen + listReload + appPath
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        /*
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
          setRecoilIsLoadingBox(false);
          navigate(ERR_URL);
        }
        */
        if (retData) {
            setRecoilIsLoadingBox(false);
            if (retData.codeNum == CONST.API_200) {
                //clog("IN HEADER POPUP : ALARM-RES : " + JSON.stringify(retData.body));
                setListReload(false);
                setAlarmList(retData.body);
            }
        }
    }, [retData]);
    function onClickDoToggleReadYn(e, alarm) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            clog("onClickDoToggleReadYn : " + alarm.readYN);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/notice/isread`,
                appQuery: {
                    "noticeId": alarm.noticeId,
                    "readYN": (alarm.readYN) ? false : true,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setParentAlarmCountReload(true);
                    setListReload(true);
                }
                else {
                }
            }
        });
    }
    function onClickDoToggleGotonReadYn(e, alarm) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            clog("onClickDoToggleGotonReadYn : " + alarm.readYN);
            let data = null;
            if (!alarm.readYN) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/api/v2/notice/isread`,
                    appQuery: {
                        "noticeId": alarm.noticeId,
                        "readYN": (alarm.readYN) ? false : true,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setParentAlarmCountReload(true);
                    }
                    else {
                        setListReload(true);
                    }
                }
            }
            setRecoilUrlInfo(alarm.link);
            navigate(alarm.link);
        });
    }
    function onClickDoAllRead(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/notice/allread`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    setParentAlarmCountReload(true);
                    setListReload(true);
                }
                else {
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header__alarm", style: { display: (isOpen) ? "" : "none", "cursor": "default" } },
            React.createElement("div", { className: "alarm__top" },
                React.createElement("p", { className: "title" },
                    "Alarm",
                    React.createElement("span", { className: "num" },
                        alarmList.length,
                        " \uAC74")),
                React.createElement("button", { type: "button", onClick: (e) => setOnlyUnread(!onlyUnread) },
                    React.createElement("span", null, (onlyUnread) ? "전체알림 표시" : "읽지 않은 항목만 표시"))),
            (alarmList.length <= 0)
                ? React.createElement("p", { className: "nodata__txt" }, "\uC9C0\uB09C 30\uC77C \uB3D9\uC548 \uBC1B\uC740 \uC54C\uB9BC\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.")
                : React.createElement("div", { className: "alarm__notice" },
                    React.createElement("p", null, "\uCD5C\uC2E0"),
                    React.createElement("button", { type: "button", className: `btn-alarmread ${(alarmCount <= 0) ? "hidden" : ""}`, onClick: (e) => onClickDoAllRead(e) },
                        React.createElement("span", null, "\uBAA8\uB450 \uC77D\uC74C"))),
            (alarmList.length > 0) &&
                React.createElement("ul", { className: "alarm__list" }, alarmList.map((alarm, idx) => (React.createElement("li", { key: `li_${idx.toString()}` },
                    React.createElement("a", { onClick: (e) => onClickDoToggleGotonReadYn(e, alarm) },
                        React.createElement("div", { className: "list__name" },
                            React.createElement("p", null, alarm.message),
                            React.createElement("button", { type: "button", className: (alarm.readYN) ? "readend" : "", onClick: (e) => onClickDoToggleReadYn(e, alarm) },
                                React.createElement("span", { className: "hide" }, "\uC0C8\uC54C\uB78C"))),
                        React.createElement("div", { className: "list__info" },
                            React.createElement("p", { className: "list__txt" },
                                React.createElement("span", { className: "tooltip" },
                                    alarm.subMessage,
                                    React.createElement("span", { className: "tooltip-text" }, alarm.subMessage))),
                            React.createElement("p", { className: "time" }, CUTIL.utc2formedstr(alarm.createdTime, "yy-MM-DD hh:mm:ss")))))))),
            (alarmList.length > 0) &&
                React.createElement("p", { className: "alarm__end" }, "\uC9C0\uB09C 30\uC77C \uB3D9\uC548 \uBC1B\uC740 \uBAA8\uB4E0 \uC54C\uB78C\uC740 \uC5EC\uAE30\uAE4C\uC9C0\uC785\uB2C8\uB2E4."))));
}
